    export interface IEscalator {
        displayName: string;
        value: number;
    }

    export class Escalator implements IEscalator {
        displayName: string;
        value: number;

        constructor(displayName?: string, value?: number) {
            this.displayName = displayName;
            this.value = value;
        }
    }